/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { HttpErrorInterceptor } from './services/interceptors/Base/http-interceptor';
import { TokenInterceptor } from './services/interceptors/Token/token';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app/app.routes';
import 'hammerjs';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(
      withInterceptors([HttpErrorInterceptor, TokenInterceptor])
    ),
    provideAnimations(),
    provideRouter(appRoutes),
  ],
});
